import { Component, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { Pagination } from '../../../../../shared/models/pagination.model';
import { User } from '../../../../../shared/models/user.model';
import { Currency } from '../../../../../shared/models/currency.model';
import Swal from 'sweetalert2';
import { LocalDataSource } from 'ng2-smart-table';
import { ReportService } from '../../../../../shared/service/report.service';
import { DateService } from '../../../../../shared/service/date.service';
import { UserService } from '../../../../../shared/service/user.service';
import { DateFormatPipe } from '../../../../../shared/pipes/jdate.pipe';
import * as XLSX from 'xlsx';
import { LazyLoadEvent } from 'primeng/api';
import { WithdrawRialStatus } from 'src/app/shared/models/withdraw.model';
import { DipositTreasury } from '../../../../../shared/models/deposit-trasury.model';
import { ProviderPipe } from 'src/app/shared/pipes/provider.pipe';
import { DepositTypePipe } from '../../../withdraw/pipes/deposit-type.pipe';
import { DateModel } from '../../../../../shared/models/date.model';

@Component({
  selector: 'app-deposit-treasury',
  templateUrl: './deposit-treasury.component.html',
  styleUrls: ['./deposit-treasury.component.scss'],
  providers: [DateFormatPipe, ProviderPipe, DepositTypePipe]
})
export class DepositTreasuryComponent implements OnInit {
  sub = new SubSink();
  tableLoading = true;
  error: any = {};
  pagination: Pagination<DipositTreasury> = new Pagination<DipositTreasury>();
  loading = true;
  includedUsers: User[] = [];
  selectedCurrency: Currency[] = [];
  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
  status!: WithdrawRialStatus;
  succeed!: boolean;
  startDate!: string;
  endDate!: string;
  source: LocalDataSource = new LocalDataSource();
  token: string | undefined;
  type!: string;

  constructor(
    private reportService: ReportService,
    private dateService: DateService,
    private userService: UserService,
    private dateFormat: DateFormatPipe
  ) {}

  filterTable($event: any = {}): void {
    this.startDate = $event.startDate ?? this.dateService.previousMonth();
    this.endDate = $event.endDate ?? this.dateService.todayStringGregorian();
    const filters: any = {
      start_time: `${this.startDate} 00:00:00`,
      end_time: `${this.endDate} 23:59:59`,
      succeed: this.succeed,
      type: this.type,
      userId: this.includedUsers
    };
    this.tableLoading = true;

    this.userService.getTreasuryDiposit(filters).subscribe(
      (response) => {
        this.tableLoading = false;
        this.pagination = response;
      },
      (error) => {
        if (error.status === 422) {
          this.Toast.fire({
            icon: 'error',
            title: error.validationError.endTime?.[0] || error.validationError.startTime?.[0]
          });
        } else {
          this.error = this.Toast.fire({ icon: 'error', title: error.text });
        }
        this.tableLoading = false;
      }
    );
  }

  exportexcel() {
    if (this.pagination.data) {
      const worksheet = XLSX.utils.json_to_sheet(
        this.pagination.data.map((res) => {
          return {
            مقدار: res.amount,
            'حساب بانکی': res.type === 'card' ? res.userCreditCard : res.userIban,
            'درگاه پرداخت': res.provider,
            'نوع پرداخت': res.type === 'card' ? 'درگاه بانکی' : 'شناسه‌دار',
            تاریخ: this.dateFormat.transform(res.createdAt, 'jYYYY/jMM/jDD HH:mm')
          };
        })
      );
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(
        workbook,
        `گزارش واریز${this.dateFormat.transform(
          this.startDate,
          'jDD_jMM_jYYYY'
        )}-${this.dateFormat.transform(this.endDate, 'jDD_jMM_jYYYY')}.xlsx`
      );
    }
  }

  getDepositList(event: LazyLoadEvent = {}, $event: any = {}): void {
    if (this.startDate === undefined && this.endDate === undefined) {
      this.startDate = $event.startDate ?? this.dateService.previousMonth();
      this.endDate = $event.endDate ?? this.dateService.todayStringGregorian();
      this.succeed = true;
    }
    this.loading = true;
    const user_id = this.includedUsers.map((user) => user.id);
    this.reportService
      .getTreasuryRialDepositList(
        user_id,
        event.rows,
        this.status,
        `${this.startDate} 00:00:00`,
        `${this.endDate} 23:59:59`,
        this.succeed,
        new Date().getTimezoneOffset() * -1,
        this.type
      )
      .subscribe((pagination) => {
        this.pagination = pagination;
        this.loading = false;
      });
  }

  ngOnInit(): void {
    this.getDepositList();
  }
}
